import React from 'react';

import { formatCurrency, isArray, isNil, PartTypes } from 'vdlib';
import LookupsHelper from 'lib/LookupsHelper';
import Store from 'data/Store';

let partTypes = null;

const loadPartTypes = () => {
  let lookups = Store.getState().app.lookups;
  partTypes =
    !isNil(lookups) && isArray(lookups.partTypes) ? lookups.partTypes : null;
};

const BidsCellRenderer = params => {
  if (!isArray(partTypes)) loadPartTypes();

  if (isNil(params.value)) return <span />;

  let newBid = params.value.find(
      b =>
        b.PartTypeID ===
        LookupsHelper.getIdByDescription(partTypes, PartTypes.New)
    ),
    usedBid = params.value.find(
      b =>
        b.PartTypeID ===
        LookupsHelper.getIdByDescription(partTypes, PartTypes.Used)
    ),
    imitationBid = params.value.find(
      b =>
        b.PartTypeID ===
        LookupsHelper.getIdByDescription(partTypes, PartTypes.Imitation)
    );
  return (
    <span>
      {[
        newBid == null ? null : (
          <span key="newbid" className="label label-success">
            {formatCurrency(newBid.Amount)}
          </span>
        ),
        usedBid == null ? null : (
          <span key="usedbid" className="label label-danger">
            {formatCurrency(usedBid.Amount)}
          </span>
        ),
        imitationBid == null ? null : (
          <span key="imitationbid" className="label label-warning">
            {formatCurrency(imitationBid.Amount)}
          </span>
        ),
      ].filter(s => s != null)}
    </span>
  );
};

export default BidsCellRenderer;
